import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

const buildSearchableEntities = (entities = [], resultArray = []) => {
  entities.forEach((entity) => {
    if (!entity.name || !entity.id) return;
    const searchableEntity = { label: entity.name, value: entity.id };
    resultArray.push(searchableEntity);
  });
  return sortBy(resultArray, ['label', 'value']);
};

const getSearchableEntities = (res) => {
  const searchableEntities = [];
  if (res.error || !res.response) return searchableEntities;
  return buildSearchableEntities(res.response, searchableEntities);
};

const getUsers = (res) => {
  const searchableEntities = [];
  if (res.error || get(res, 'response.userList.length') === 0) return searchableEntities;
  res.response.userList.forEach((user) => {
    if (!user.name || !user.id) return;
    const searchableUser = { label: user.name, value: user.id };
    searchableEntities.push(searchableUser);
  });
  return sortBy(searchableEntities, ['label', 'value']);
};

export {
  buildSearchableEntities,
  getSearchableEntities,
  getUsers,
};
